import React from 'react';
import { motion } from 'framer-motion';
const technologies = ['React', 'TypeScript', 'Node.js', 'Swift', 'Kotlin', 'AWS', 'GraphQL', 'Rust'];
export function TechStackSection() {
  return <section className="py-20 bg-slate-900 text-white overflow-hidden" data-id="element-77">
      <div className="container mx-auto px-4 md:px-6 text-center" data-id="element-78">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12" data-id="element-79">
          <h2 className="text-3xl font-bold mb-4" data-id="element-80">
            Built With Modern Technology
          </h2>
          <p className="text-slate-400 max-w-2xl mx-auto" data-id="element-81">
            We leverage cutting-edge tools and frameworks to deliver reliable,
            scalable, and performant applications.
          </p>
        </motion.div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-8" data-id="element-82">
          {technologies.map((tech, index) => <motion.div key={tech} initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="px-6 py-3 bg-slate-800 rounded-full border border-slate-700 text-slate-300 font-medium text-sm md:text-base" data-id="element-83">
              {tech}
            </motion.div>)}
        </div>
      </div>
    </section>;
}